var Handlebars = require("../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var helper;

  return "    <div class=\"lighterErrMsg\">\n        "
    + container.escapeExpression(((helper = (helper = helpers.errorMsg || (depth0 != null ? depth0.errorMsg : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"errorMsg","hash":{},"data":data}) : helper)))
    + "\n    </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "    <div id=\"esErrMessage\">\n        <div id=\"esErrHead\">\n            <span class=\"icon icon-attention-circled\"></span>\n            <span>Error</span>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.notFoundAgainOnServer : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            </span>\n        </div>\n        <div id=\"esErrContent\" title=\""
    + alias4(((helper = (helper = helpers.errorMsg || (depth0 != null ? depth0.errorMsg : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"errorMsg","hash":{},"data":data}) : helper)))
    + "\">\n            "
    + alias4(((helper = (helper = helpers.errorMsg || (depth0 != null ? depth0.errorMsg : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"errorMsg","hash":{},"data":data}) : helper)))
    + "\n        </div>\n    </div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "                    <div>\n                        <span class=\"lbl-again label label-important\">again</span>\n                    </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.notFoundOnServer : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/content/error/template.hbs
 ** module id = 553
 ** module chunks = 0
 **/